<template>
  <div>
    <div class="row">
      <div class="col-12">
        <ActionDropMenu class="float-right">
          <DropdownMenuItem @click="exportDataCSV" icon="fa-file-csv">Export CSV</DropdownMenuItem>
        </ActionDropMenu>
        
        <ReportFilterPopover
          class="float-right mr-2"
          headerTitle="Invoice Value Filter"
          :showApplyButton="true"
          :showResetButton="true"
          @apply="applyInvoiceSummaryFilter"
          @reset="resetInvoiceSummaryFilter">
          <template v-slot:popover>
            <ReportDateRangeSelect 
              :startDate="editingStartDate"
              :endDate="editingEndDate"
              @updateStartDate="editingStartDate = $event"
              @updateEndDate="editingEndDate = $event"
            />
            <ReportFilterGroup label="Account Location">
              <AccountLocationMultiSelect v-model="editingAccountLocationIdList" />
            </ReportFilterGroup>
          </template>
          <template v-slot:filterDisplay>
            <div>
              <i class="far fa-calendar mr-2"></i>{{startDate | formatDate}} - {{endDate | formatDate}}
            </div>
            <ReportFilterDisplayAccountLocation :accountLocationId="accountLocationId" />            
            
          </template>
        </ReportFilterPopover>
        <ContentTitle>{{title}}</ContentTitle>
        <ContentSubTitle>Based on invoices created between {{formatDate(startDate)}} and {{formatDate(endDate)}}</ContentSubTitle>
        <ContentSubTitle>All values are {{taxName}} inclusive</ContentSubTitle>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <StaticDataTable class="static-table-list" :striped="true">
          <template v-slot:header>
            <tr>
              <th>Name</th>
              <th v-for="month of monthList" :key="month.key">
                {{month.title}}
              </th>
              <th>Total</th>
            </tr>
          </template>
          <template v-slot:body>
            <template v-for="(valueInfo, index) in valueList">
              <tr :key="`invoice-info-${index}`">
                <td class="font-weight-bold">
                  <LinkStock v-if="valueInfo.stockId" :name="valueInfo.name" :id="valueInfo.stockId" />
                  <LinkContact v-else-if="valueInfo.contactId" :name="valueInfo.name" :id="valueInfo.contactId" />
                  <span v-else>{{valueInfo.name}}</span>
                </td>
                <td v-for="monthData of valueInfo.monthList" :key="monthData.key">
                  <span v-html="monthData.displayValue"></span>
                </td>
                <td class="font-weight-bold">
                  <span v-html="valueInfo.displayValue"></span>
                </td>
              </tr>
            </template>
          </template>
          <template v-slot:empty v-if="valueList.length == 0">
            No data found
          </template>
        </StaticDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import buildUrl from 'build-url'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'
import AccountLocationMultiSelect from '@/modules/admin/components/accountLocationMultiSelect'
import ReportFilterDisplayAccountLocation from '@/components/reporting/reportFilterDisplayAccountLocation'

export default {
  name: 'InvoiceValueSummaryList',
  components: {
    ReportFilterPopover,
    ReportDateRangeSelect,
    AccountLocationMultiSelect,
    ReportFilterDisplayAccountLocation,
    ReportFilterGroup
  },
  props: {
    title: String,
    startDate: String,
    endDate: String,
    accountLocationId: [Array, Number],
    valueList: Array,
    monthList: Array,
    reportField: String
  },
  data() {
    return {
      editingStartDate: this.startDate,
      editingEndDate: this.endDate,
      editingAccountLocationIdList: this.accountLocationId || []
    }
  },
  watch: {
    'startDate': function() {
      this.editingStartDate = this.startDate
    },
    'endDate': function() {
      this.editingEndDate = this.endDate
    },
    accountLocationId: function() {
      this.editingAccountLocationIdList = this.accountLocationId || []
    }
  },
  computed: {
    ...mapState({
      taxName: state => state.account.salesTaxRate.name
    }),
  },
  methods: {
    applyInvoiceSummaryFilter() {
      this.$emit('applyFilter', { startDate: this.editingStartDate, endDate: this.editingEndDate, accountLocationId: this.editingAccountLocationIdList })
    },
    resetInvoiceSummaryFilter() {
      this.$emit('resetFilter')
    },
    exportDataCSV() {
      var summaryFilter = {
        startDate: this.startDate,
        endDate: this.endDate,
        maxGroupSize: 0,
        includeMonthBreakdown: true,
        exportReport: this.reportField,
        accountLocationId: this.accountLocationId,
        format: 'csv'
      }

      let queryString = buildUrl({ queryParams: summaryFilter })

      this.$apiService.reportingService.generateReportSignedURL(`/intelligence/accounts/invoices/fullsummary${queryString}`)
      .then(response => {
        window.location.href = response.data.url
      })

    }
  }
}
</script>